import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgCarService
    ,FvmsApiDtgTeamService
    ,FvmsApiAuthService
} from "src/app/shared/service";
import {
    DtgActionType
} from "src/app/shared/vo";

@Component({
    templateUrl: "./dtg.manage.car.ext.main.form.component.html"
    ,providers: []
})
export class DtgManageCarExtMainFormComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() companyId:string;
    @Input() teamId:string;
    @Input() dtgUnitId:string;
    @Input() dtgActionType:DtgActionType;
    formGroup: FormGroup;
    submitted:boolean = false;
    readOnly:boolean = true;
    DtgActionType = DtgActionType;
    listCarType:any;
    listTeam:any;
    currentUserInfo:any;
    userGroupId:number;
    companyInfo:any;
    
    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiDtgCarService:FvmsApiDtgCarService
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsCommonService:FvmsCommonService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
     }

    ngOnInit() {
        this.initForm();
        this.reloadListItemCarType();
        this.reloadListItemTeam();
        switch(this.dtgActionType){
            case DtgActionType.create:
                this.readOnly = false;
                break;
            case DtgActionType.update:
            case DtgActionType.delete:
                this.readOnly = false;
                this.selectOneCarInfo();
                break;
            case DtgActionType.read:
            default:
                this.readOnly = true;
                this.selectOneCarInfo();
                this.formGroup.disable();
                break;
        }
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    initForm(){
        this.formGroup = this.formBuilder.group({
            dtgUnitId:this.dtgUnitId
            ,deviceTypeId:0
            ,dtgCarNo:null
            ,dtgVin:[
                null
                ,[
                    Validators.maxLength(17)
                    ,Validators.pattern("[a-zA-Z0-9]{0,17}")
                ]
            ]
            ,dtgCarType:"41"
            ,dtgCarTypeNm:null
            ,companyId:[
                this.companyId
                ,[
                    Validators.required
                ]
            ]
            ,companyNm:null
            ,extCompanyId:[
                this.companyId
                ,[
                    Validators.required
                ]
            ]
            ,extCompanyNm:null
            ,dtgTeamId:this.teamId
            ,dtgTeamNm:null
            ,dtgDeviceSn:null
            ,dtgModelNo:null
            ,dtgFirmwareInfo:null
            ,updateDt:null
        });
    }

    get f() { return this.formGroup.controls; }

    selectOneCarInfo(){
        let searchInfo = {
            dtgUnitId : this.dtgUnitId
        };
        this.fvmsApiDtgCarService.getCarDetailExt(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.formGroup.patchValue(apiResponse.resultValue);
                }
            });
    }

    // 셀렉트박스 차량종류
    reloadListItemCarType(){
        this.fvmsApiDtgCarService.getListCarType(null)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listCarType = apiResponse.resultValue;
                    this.listCarType = this.listCarType.filter((val,idx) => val.dtgCarType !== "0");
                }
            });
    }

    // 셀렉트박스 그룹목록
    reloadListItemTeam(){
        let searchInfo = {
            companyId : this.companyInfo.companyId
            ,dtgTeamId : this.currentUserInfo.teamId || ''
            ,searchValue : null
        };
        let pagingInfoTeam = {
            "curPage":1
            ,"pageSize":1000
        };
        this.fvmsApiDtgTeamService.getListTeam(searchInfo,pagingInfoTeam)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                }
            });
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    clickSave(){
        this.onSubmit();
    }

    onSubmit(){
        this.submitted = true;
        // console.log("onSubmit",this.f);
        if (this.formGroup.invalid) {
            return;
        }

        let carInfo = {
             dtgUnitId:this.f.dtgUnitId.value
            ,dtgTeamId:this.f.dtgTeamId.value
        };
        // console.log("onSubmit",carInfo);

        this.fvmsApiDtgCarService.upsertCarExt(carInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    
                }
                this.activeModal.close({
                    "result":"ok"
                });
            });
        return;
    }
}